const styles = theme => ({
  table: {
    width: '100%',
  },
  rootStyle: {
    width: '100%',
    maxWidth: 964,
    backgroundColor: '#F4F6F8',
    marginTop: 50,
    marginBottom: 30,
    height: 'auto',
    padding: 12,
    borderRadius: 16,
    '@media (max-width: 600px)': {
      width: '380px !important',
    },
  },
  rootHeader: {
    maxWidth: 964,
    height: 64,
  },
  typographyHeader: {
    fontSize: '20px',
    color: '#002E47',
    marginTop: '20px',
    marginBottom: '10px',
    width: '100%',
    maxWidth: 916,
    height: 24,
  },
  tableContainer: {

    backgroundColor: '#F4F6F8',
    marginTop: 10,
    marginBottom: 24,
  },
})

export default styles
